import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Form } from 'react-bootstrap';
import Tabela from '../../components/Misc/Tabela/Tabela.jsx';
import { useRevisaoMateriaPrima } from "../../contexts/MP/RevisaoMateriaPrima.js";
import styles from '../../styles/MP/RevisaoMateriaPrima.module.scss';
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import AuditoriaModal from '../../components/MP/RevisaoMateriaPrima/AuditoriaModal.jsx';
import FilterForm from '../../components/MP/RevisaoMateriaPrima/FilterForm.jsx';
import LoteModal from '../../components/MP/RevisaoMateriaPrima/LoteModal.jsx';
import DefeitoModal from '../../components/MP/RevisaoMateriaPrima/DefeitoModal.jsx';
import TonalidadeModal from '../../components/MP/RevisaoMateriaPrima/TonalidadeModal.jsx';
import MiniModalEditarNomePeca from '../../components/MP/RevisaoMateriaPrima/MiniModalEditarNomePeca.jsx';
import useMainTable from '../../components/MP/RevisaoMateriaPrima/MainTable.jsx';
import AnaliseDefeitosBlock from '../../components/MP/RevisaoMateriaPrima/AnaliseDefeitosBlock.jsx';

const RevisaoMateriaPrimaMain = () => {
    const {
        mainData,
        setMainData,
        filterObj,
        handleSetFilterObj,
        handleFilterButtonClick,
        isRevisorView,
        setIsRevisorView,
        marcarAuditoria,
        desmarcarAuditoria,
        statusOptions,
        continuarLotesPecas,
        buscarLotesNumericosPorId,
        patchLotesPecas,
        registrarAnalisePeca,
        fetchAnalisePecas,
        fetchDefeitosPecas,
        fetchOpcoesDefeito,
        fetchOpcoesLocalizacao,
        fetchOpcoesTamanho,
        deletarAnalisePecaDefeito,
        registrarAnalisePecaComDefeitos,
        deletarDefeitoAnalisePeca,
        editarTipoTecido,
        getModalTonalidadeTipo,
        fetchIndicesModalTonalidade,
        finalizarRevisaoPedido,
        patchNomePeca,
        fetchStatusAtualPedido,
        handleFilterMainGrid
    } = useRevisaoMateriaPrima();


    // Estados dos modais organizados
    // 1. Modal de check
    const [showModal, setShowModal] = useState(false);
    const [showUncheckModal, setShowUncheckModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [checkedRows, setCheckedRows] = useState({});
    const [activeRowId, setActiveRowId] = useState(null);
    const [rowToUncheck, setRowToUncheck] = useState(null);

    // 2. Modal da linha
    const [showRowModal, setShowRowModal] = useState(false);
    const [rowModalData, setRowModalData] = useState(null);
    const [numLotes, setNumLotes] = useState(0);
    const [lotesQtd, setLotesQtd] = useState([]);

    // 3. Modal principal de lançamento
    const [showMainLancamentoModal, setShowMainLancamentoModal] = useState(false);
    const [mainLancamentoRowData, setMainLancamentoRowData] = useState(null);
    const [lotesOpcoes, setLotesOpcoes] = useState([]);

    // Estados e funções de ordenação da tabela movidos para MainTable

    // Estado para armazenar as análises de peça já feitas e analisadas
    const [analisesPeca, setAnalisesPeca] = useState([]);
    const [pecasAnalisadas, setPecasAnalisadas] = useState([]);
    // Estado do accordion de análises
    const [openAnaliseAccordion, setOpenAnaliseAccordion] = useState(true);
    // Estado do accordion de defeitos
    const [openDefeitosAccordion, setOpenDefeitosAccordion] = useState(false);

    // Estado para controlar o sub-modal de defeitos
    const [showDefeitoSubModal, setShowDefeitoSubModal] = useState(false);
    // Array de defeitos: cada objeto representa um modal (principal e extras)
    const [defeitos, setDefeitos] = useState([
        { defeito: '', localizacao: '', tamanho: '', consideracao: '', condenar: false }
    ]);

    // States para armazenar as opções vindas do backend para os selects do sub-modal de defeitos
    const [opcoesDefeito, setOpcoesDefeito] = useState([]);
    const [opcoesLocalizacao, setOpcoesLocalizacao] = useState([]);
    const [opcoesTamanho, setOpcoesTamanho] = useState([]);

    // Estado para armazenar o campo de fotos e status
    const [campoFotos, setCampoFotos] = useState({}); // Estado para armazenar foto/status por campo

    // Estado para acumular imagens de tonalidade entre modais (Solução 1 - front-end)
    const [tonalidadeImagensAcumuladas, setTonalidadeImagensAcumuladas] = useState([]);

    // state para armazenar os defeitos no grid
    const [defeitosGrid, setDefeitosGrid] = useState([]);

    // Novo estado e função para abrir o modal de tonalidade e inserir quando finalizar
    const [showTonalidadeModal, setShowTonalidadeModal] = useState(false);
    const [onTonalidadeFinish, setOnTonalidadeFinish] = useState(null);

    // Adicionando showTonalidadeModal

    // Estado para tipo de modal tonalidade
    const [modalTonalidadeTipo, setModalTonalidadeTipo] = useState(null);

    // Estado para tipo de acabamento
    const [tipoAcabamento, setTipoAcabamento] = useState('');
    const [acabamentoConfirmado, setAcabamentoConfirmado] = useState('');

    // Estado para armazenar os índices do modal tonalidade
    const [indicesModalTonalidade, setIndicesModalTonalidade] = useState([]);

    // Estado para índice e status selecionado nos modais de tonalidade
    const [statusSelecionado, setStatusSelecionado] = useState({
        foto1: '',
        foto2: '',
        foto3: '',
        foto4: '',
        foto5: '',
    });

    const [indiceSelecionado, setIndiceSelecionado] = useState({
        foto1: '', // primeira modal, foto 1
        foto2: '', // primeira modal, foto 2
        foto3: '', // primeira modal, foto 3
        foto4: '', // segunda modal, foto 4
        foto5: '', // última modal, foto 5
    });

    // Estados para lotes customizados e peças a analisar por lote
    const [lotesCustomizados, setLotesCustomizados] = useState([]);
    const [analisarTotalPecasArr, setAnalisarTotalPecasArr] = useState(Array(numLotes).fill(0));

    // Estado para controlar a abertura do menu de peças
    const [menuIsOpenPeca, setMenuIsOpenPeca] = useState(false);

    // Estados para o mini modal de editar nome da peça
    const [showMiniModalEditarNomePeca, setShowMiniModalEditarNomePeca] = useState(false);
    const [miniModalPecaNum, setMiniModalPecaNum] = useState(null); // peça selecionada (número)

    // Estado para armazenar o status atual do pedido
    const [statusAtualPedido, setStatusAtualPedido] = useState(null);

    // Estado para controlar o carregamento do modal principal
    const [loadingModal, setLoadingModal] = useState(false);

    // Handlers para abrir o mini modal: guardamos apenas o número da peça e deixamos a lógica de salvar no modal
    const handleAbrirMiniModalEditarNomePeca = (num) => {
        setMiniModalPecaNum(num);
        setShowMiniModalEditarNomePeca(true);
    };

    const handleShowPDF = (url) => {
        window.open(url, '_blank');
    };

    // Buscar opções ao abrir o sub-modal de defeitos
    useEffect(() => {
        if (showDefeitoSubModal) {
            fetchOpcoesDefeito().then(setOpcoesDefeito);
            fetchOpcoesLocalizacao().then(setOpcoesLocalizacao);
            fetchOpcoesTamanho().then(setOpcoesTamanho);
        }
    }, [showDefeitoSubModal]);

    // Função utilitária para calcular as peças disponíveis para o lote selecionado (lote principal)
    function retornaPecasDoLote(totalLotes, numeroDoLote, analisarTotalPecasArr) {
        const infoLote = totalLotes.find(item => Number(item.lote) === Number(numeroDoLote));
        const indiceLote = totalLotes.findIndex(lote => Number(lote.lote) === Number(numeroDoLote));
        if (indiceLote === -1) return [];

        // Gera todas as peças de todos os lotes
        const todasAsPecas = [];
        let contador = 1;
        for (let l = 0; l < totalLotes.length; l++) {
            const qtde = totalLotes[l].qtdePecas;
            for (let i = 0; i < qtde; i++) {
                todasAsPecas.push(contador);
                contador++;
            }
        }

        // Gera as peças do lote selecionado
        const somaqtdePecasLotesAnteriores = totalLotes
            .slice(0, indiceLote)
            .reduce((acc, curr) => acc + curr.qtdePecas, 0);
        const inicioDoArray = somaqtdePecasLotesAnteriores + 1;
        const fimDoArray = inicioDoArray + totalLotes[indiceLote].qtdePecas - 1;
        const arrayDePecasPorLote = [];
        for (let i = inicioDoArray; i <= fimDoArray; i++) {
            arrayDePecasPorLote.push(i);
        }

        // Se ESTE lote tiver análise 100%, retorna todas as peças apenas deste lote
        if (analisarTotalPecasArr && (analisarTotalPecasArr[indiceLote] === true || analisarTotalPecasArr[indiceLote] === 1)) {
            return arrayDePecasPorLote;
        }

        // Caso contrário: comportamento padrão (20% ou mínimo 2)
        let qtdeDePecasParaAnalise = infoLote.qtdePecas * 0.2;
        if (qtdeDePecasParaAnalise < 2) qtdeDePecasParaAnalise = 2;
        let qtdeArredondadaDePecasParaAnalise = Math.ceil(qtdeDePecasParaAnalise);
        return arrayDePecasPorLote.slice(0, qtdeArredondadaDePecasParaAnalise);
    }

    // Funções dos modais
    // 1. Modal de check
    const handleCancel = () => {
        setShowModal(false);
        setSelectedDate('');
        if (activeRowId !== null) {
            setCheckedRows(prev => ({ ...prev, [activeRowId]: false }));
            setActiveRowId(null);
        }
    };

    const handleCheckboxChange = (rowId) => (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setCheckedRows(prev => ({ ...prev, [rowId]: true }));
            setActiveRowId(rowId);
            setShowModal(true);
        } else {
            setRowToUncheck(rowId);
            setShowUncheckModal(true);
        }
    };
    const handleUncheckCancel = () => {
        setShowUncheckModal(false);
        setRowToUncheck(null);
    };

    // 2. Modal da linha
    const handleRowClick = (id) => {
        const row = mainData.find(r => r.idMpTriangulacaoRev === id);
        if (row && (row.ehPreLancamento === 0 || row.ehPreLancamento === false)) {
            setMainLancamentoRowData(row);
            setShowMainLancamentoModal(true);
        } else {
            // Sempre resetar os estados antes de setar os novos valores
            setRowModalData(null);
            setNumLotes(0);
            setLotesQtd([]);
            setAnalisarTotalPecasArr([]);
            setLotesCustomizados([]);
            setTimeout(() => {
                setRowModalData(row);
                if (row && Array.isArray(row.LotesPecas) && row.LotesPecas.length > 0) {
                    setNumLotes(row.LotesPecas.length);
                    setLotesQtd(row.LotesPecas.map(l => String(l.qtdePecas)));
                    setAnalisarTotalPecasArr(row.LotesPecas.map(l => l.analisarTotalPecas ? 1 : 0));
                    setLotesCustomizados(row.LotesPecas.map(l => String(l.loteCustomizado || '')));
                }
                setShowRowModal(true);
            }, 0);
        }
    };

    // Sempre buscar e sincronizar os dados de lotes/peças do backend ao abrir o modal principal
    useEffect(() => {
        async function fetchLotesAndLotesPecas() {
            if (showMainLancamentoModal && mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev) {
                setLoadingModal(true);
                try {
                    const lotes = await buscarLotesNumericosPorId(mainLancamentoRowData.idMpTriangulacaoRev);
                    setLotesOpcoes(lotes);
                    if (lotes.length > 0 && (!mainLancamentoRowData.lote || mainLancamentoRowData.lote === '')) {
                        setMainLancamentoRowData(prev => prev ? { ...prev, lote: String(lotes[0]) } : prev);
                    }

                    const res = await api.get(`/mp/triangulacao-revisao/pedidos/lotes/pecas/id/${mainLancamentoRowData.idMpTriangulacaoRev}`);
                    const lotesPecas = Array.isArray(res.data) ? res.data : res.data.rows;
                    if (Array.isArray(lotesPecas) && lotesPecas.length > 0) {
                        setMainLancamentoRowData(prev => prev ? { ...prev, LotesPecas: lotesPecas } : prev);
                        setMainData(prev => prev.map(row =>
                            row.idMpTriangulacaoRev === mainLancamentoRowData.idMpTriangulacaoRev
                                ? { ...row, LotesPecas: lotesPecas }
                                : row
                        ));
                        setAnalisarTotalPecasArr(lotesPecas.map(l => l.analisarTotalPecas ? 1 : 0));
                    }
                } catch (e) {
                } finally {
                    setLoadingModal(false);
                }
            }
            if (!showMainLancamentoModal) {
                setLotesOpcoes([]);
            }
        }
        fetchLotesAndLotesPecas();
    }, [showMainLancamentoModal, mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev]);

    // Buscar análises e defeitos de peça ao abrir o modal principal
    useEffect(() => {
        async function fetchAnalisesEDefeitosAoAbrirModal() {
            if (showMainLancamentoModal && mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev) {
                const analises = await fetchAnalisePecas(mainLancamentoRowData.idMpTriangulacaoRev);
                setAnalisesPeca(Array.isArray(analises) ? analises : []);

                const defeitos = await fetchDefeitosPecas(mainLancamentoRowData.idMpTriangulacaoRev);
                setDefeitosGrid(Array.isArray(defeitos) ? defeitos : []);
            }
            if (!showMainLancamentoModal) {
                setAnalisesPeca([]);
                setDefeitosGrid([]);
            }
        }
        fetchAnalisesEDefeitosAoAbrirModal();
    }, [showMainLancamentoModal, mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev]);


    const handleCloseRowModal = () => {
        setShowRowModal(false);
        setRowModalData(null);
    };

    // 3. Modal principal de lançamento
    const handleCloseMainLancamentoModal = () => {
        setShowMainLancamentoModal(false);
        setMainLancamentoRowData(null);
        setCampoFotos({});
    };

    // Efeito para checkedRows
    useEffect(() => {
        if (mainData && Array.isArray(mainData)) {
            const checked = {};
            mainData.forEach(row => {
                if (row.checkAuditor) checked[row.idMpTriangulacaoRev] = true;
            });
            setCheckedRows(checked);
        }
    }, [mainData]);


    useEffect(() => {
        if (showTonalidadeModal && mainLancamentoRowData?.idMpTriangulacaoRev && mainLancamentoRowData?.lote) {
            fetchIndicesModalTonalidade(mainLancamentoRowData.idMpTriangulacaoRev, mainLancamentoRowData.lote)
                .then(indices => {
                    setIndicesModalTonalidade(Array.isArray(indices) ? indices : []);
                })
                .catch(error => {
                    setIndicesModalTonalidade([]);
                });
        }
    }, [showTonalidadeModal, mainLancamentoRowData?.idMpTriangulacaoRev, mainLancamentoRowData?.lote]);

    // Definições do Status de tonalidade
    const aprovadorTecidoTinto = ['4/5', '5'];
    const aprovadorTecidoEstampado = ['4', '4/5', '5'];
    const statusTonalidade = [
        { value: 'aprovado', label: 'Aprovado' },
        { value: 'reprovado', label: 'Reprovado' }
    ];


    // Definir tipoTecidoAtual dentro do componente, antes do useEffect
    const tipoTecidoAtual = mainLancamentoRowData?.tipoTecido;
    // useEffect para monitorar mudanças em indiceSelecionado e tipoTecidoAtual
    useEffect(() => {
        const novasStatus = { ...statusSelecionado };
        ['foto1', 'foto2', 'foto3', 'foto4', 'foto5'].forEach(foto => {
            const indice = indiceSelecionado[foto];
            let recomendado = '';
            if (!indice) {
                novasStatus[foto] = '';
                return;
            }
            if (tipoTecidoAtual === 'tinto') {
                recomendado = aprovadorTecidoTinto.includes(indice) ? statusTonalidade[0].value : statusTonalidade[1].value;
            } else if (tipoTecidoAtual === 'estampado') {
                recomendado = aprovadorTecidoEstampado.includes(indice) ? statusTonalidade[0].value : statusTonalidade[1].value;
            }
            novasStatus[foto] = recomendado;
        });
        setStatusSelecionado(novasStatus);
    }, [indiceSelecionado, tipoTecidoAtual]);

    // Defina a função fora do useEffect para poder reutilizar
    const carregarStatus = useCallback(async () => {
        if (showMainLancamentoModal && mainLancamentoRowData?.idMpTriangulacaoRev) {
            const result = await fetchStatusAtualPedido(mainLancamentoRowData.idMpTriangulacaoRev);
            if (result) setStatusAtualPedido(result.statusAtualRevisaoPedido);;
        }
    }, [showMainLancamentoModal, mainLancamentoRowData?.idMpTriangulacaoRev]);

    // useEffect só para quando abrir o modal
    useEffect(() => {
        carregarStatus();
    }, [showMainLancamentoModal, mainLancamentoRowData?.idMpTriangulacaoRev, carregarStatus]);


    // Componentes dos modais
    // 1. Modal de check
    const UncheckModal = ({ show, onClose }) => {
        if (!show) return null;
        const handleSim = async () => {
            if (!rowToUncheck) return;
            await desmarcarAuditoria(rowToUncheck);
            setCheckedRows(prev => ({ ...prev, [rowToUncheck]: false }));
            setShowUncheckModal(false);
            setRowToUncheck(null);
        };

        return (
            <div className={styles.modalOverlay}>
                <div className={styles.modalBox}>
                    <button
                        className={styles.modalCloseBtn}
                        onClick={onClose}
                        aria-label="Fechar"
                        type="button"
                    >
                        ×
                    </button>
                    <div className={styles.confirmModalRow}>
                        <div>
                            Tem certeza que deseja desmarcar a auditoria?
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
                        <Button className={styles.confirmModalBtnDanger} onClick={handleSim}>Sim</Button>
                        <Button className={styles.modalBtn} onClick={onClose}>Não</Button>
                    </div>
                </div>
            </div>
        );
    };

    const MiniModalAuditoria = ({ show, onClose, date, setDate }) => {
        return (
            <AuditoriaModal 
                show={show}
                onClose={onClose}
                date={date}
                setDate={setDate}
                mainData={mainData}
                activeRowId={activeRowId}
                marcarAuditoria={marcarAuditoria}
                setShowModal={setShowModal}
                setSelectedDate={setSelectedDate}
                setCheckedRows={setCheckedRows}
                setActiveRowId={setActiveRowId}
                styles={styles}
            />
        );
    };

    // Configuração da tabela principal usando o hook useMainTable
    const tableConfig = useMainTable({
        mainData,
        setMainData,
        isRevisorView,
        checkedRows,
        handleCheckboxChange,
        handleShowPDF,
        handleRowClick
    });

    // Atualiza pecasAnalisadas sempre que analisesPeca mudar
    useEffect(() => {
        setPecasAnalisadas(analisesPeca.map(a => String(a.peca)));
    }, [analisesPeca]);


    // Estilo padrão para todos os SelectInput do sub-modal defeitos
    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '40px',
            height: '60px',
            borderRadius: '4px',
            borderColor: '#d9d9d9',
            boxShadow: 'none',
            background: '#fff',
            color: '#22334a',
            padding: '0 4px',
            marginTop: '-18px',
            maxWidth: '340px',
            width: '100%',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            fontSize: '14px',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            color: '#22334a',
            background: state.isSelected ? '#e6f0fa' : state.isFocused ? '#f5faff' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#22334a',
            whiteSpace: 'normal',
            overflow: 'visible',
            textOverflow: 'unset',
            maxWidth: '100%',
        }),
    };

    // useEffect para atualizar análises e defeitos quando o idMpTriangulacaoRev mudar
    const idMpTriangulacaoRev = mainLancamentoRowData?.idMpTriangulacaoRev;
    useEffect(() => {
        if (!idMpTriangulacaoRev) return; // Só executa se o id existir

        const fetchUpdatedData = async () => {
            try {
                const updatedAnalises = await fetchAnalisePecas(idMpTriangulacaoRev);
                setAnalisesPeca(updatedAnalises);

                const updatedDefeitos = await fetchDefeitosPecas(idMpTriangulacaoRev);
                setDefeitosGrid(updatedDefeitos);
            } catch (error) {
            }
        };

        fetchUpdatedData();
    }, [idMpTriangulacaoRev]);

    return (
        <div className={styles.mainContainer}>
            <FilterForm
                filterObj={filterObj}
                handleSetFilterObj={handleSetFilterObj}
                handleFilterButtonClick={handleFilterButtonClick}
                statusOptions={statusOptions}
                isRevisorView={isRevisorView}
                setIsRevisorView={setIsRevisorView}
                styles={styles}
            />
            <div>
                <Tabela
                    columns={tableConfig.columns}
                    data={mainData}
                    pagination={true}
                    customStylesOverrider={tableConfig.customStyles}
                    backgroundColor={'#202D3B'}
                    paginationPerPage={30}
                    rowClickedFn={row => handleRowClick(row.idMpTriangulacaoRev)}
                />
            </div>
                    {/* Modal principal de lançamento */}
                    {showMainLancamentoModal && (
                        <div className={styles.modalOverlay}>
                            <div className={styles.loteModalBox} style={{ width: '95%', position: 'relative' }}>
                                <button
                                    className={styles.modalCloseBtn}
                                    onClick={handleCloseMainLancamentoModal}
                                    aria-label="Fechar"
                                    type="button"
                                >
                                    ×
                                </button>
                                {/* BLOCO 1: Cabeçalho com infos do pedido */}
                                <div className={styles.lancamentoHeaderBox}>
                                    {loadingModal && (
                                        <div style={{
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            width: '100vw',
                                            height: '100vh',
                                            background: 'rgba(19, 16, 16, 0.7)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 9999
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 12
                                            }}>
                                                <div className="spinner-border" role="status" style={{ width: 48, height: 48, color: '#fff', borderColor: '#fff' }}>
                                                    <span className="visually-hidden">Carregando...</span>
                                                </div>
                                                <span style={{ color: '#fff', fontWeight: 500, fontSize: '1.1rem', textShadow: '0 1px 6px #222' }}>Carregando dados...</span>
                                            </div>
                                        </div>
                                    )}
                                    {[
                                        { label: 'PEDIDO', key: 'pedido' },
                                        { label: 'MATERIAL', key: 'material' },
                                        { label: 'COR', key: 'corMaterial' },
                                        { label: 'FORNECEDOR', key: 'fornecedor' },
                                        { label: 'DESCRIÇÃO MATERIAL', key: 'descMaterial', withTitle: true, isLong: true },
                                        { label: 'DESCRIÇÃO Cor', key: 'descCor', withTitle: true, isLong: true },
                                        { label: 'QUANTIDADE', key: 'qtdeEntregar' },
                                        { label: 'TIPO/MÊS LOJA', key: 'tipoEntradaLoja' },
                                        { label: 'MARCA', key: 'marca' },
                                        { label: 'QTDE PEÇAS', key: 'qtdePecas' },
                                        { label: 'COLEÇÃO', key: 'colecao' },
                                        { label: 'LARGURA CADASTRADA', key: 'larguraCadastrada' }
                                    ].map((item) => {
                                        let value = '';
                                        if (mainLancamentoRowData) {
                                            if (item.key === 'qtdePecas') {
                                                // Somar todas as peças dos lotes (total do pedido) — requisito: exibir soma de todos os lotes
                                                const lotesPecasArr = Array.isArray(mainLancamentoRowData?.LotesPecas) ? mainLancamentoRowData.LotesPecas : [];
                                                if (lotesPecasArr.length > 0) {
                                                    const total = lotesPecasArr.reduce((acc, l) => {
                                                        const q = l.qtdePecas ?? l.qtde ?? l.qtde_pecas ?? l.quantidade ?? 0;
                                                        const n = Number(q);
                                                        return acc + (isNaN(n) ? 0 : n);
                                                    }, 0);
                                                    value = total;
                                                } else {
                                                    value = mainLancamentoRowData[item.key] ?? '';
                                                }
                                            } else {
                                                value = mainLancamentoRowData[item.key] ?? '';
                                            }
                                        }
                                        const isLong = item.isLong && typeof value === 'string' && value.length > 18;
                                        return (
                                            <div
                                                key={item.key}
                                                className={`${styles.lancamentoHeaderItem} ${item.isLong ? styles.descLong : ''}`}
                                            >
                                                <div className={styles.lancamentoHeaderLabel}>
                                                    {item.label}
                                                </div>
                                                <div
                                                    className={styles.lancamentoHeaderValue}
                                                    title={item.withTitle && (isLong || value.length > 0) ? value : undefined}
                                                >
                                                    {value}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* BLOCO 2: Detalhes de lote (MESMO ESTILO) */}
                                <div className={styles.lancamentoHeaderBox} style={{ marginTop: '30px', display: (acabamentoConfirmado || (mainLancamentoRowData?.tipoTecido === 'tinto' || mainLancamentoRowData?.tipoTecido === 'estampado')) ? 'flex' : 'none' }}>
                                    <div className={styles.lancamentoHeaderItem} style={{ minWidth: 80, maxWidth: 120, marginRight: 15, position: 'relative' }}>
                                        <div className={styles.lancamentoHeaderLabel}>
                                            LOTE
                                            <div>
                                                <button
                                                    className={styles.menuButton}
                                                    title="Editar lotes e peças"
                                                    onClick={() => {
                                                        if (mainLancamentoRowData) {
                                                            setRowModalData(mainLancamentoRowData);
                                                            if (mainLancamentoRowData && Array.isArray(mainLancamentoRowData.LotesPecas) && mainLancamentoRowData.LotesPecas.length > 0) {
                                                                setNumLotes(mainLancamentoRowData.LotesPecas.length);
                                                                setLotesQtd(mainLancamentoRowData.LotesPecas.map(l => String(l.qtdePecas)));
                                                                setLotesCustomizados(mainLancamentoRowData.LotesPecas.map(l => String(l.loteCustomizado || '')));
                                                            } else {
                                                                setNumLotes(0);
                                                                setLotesQtd([]);
                                                            }
                                                            setShowRowModal(true);
                                                        }
                                                    }}
                                                    type="button"
                                                >
                                                    &#9776;
                                                </button>
                                            </div>
                                        </div>
                                        <Form.Select
                                            className={styles.lancamentoHeaderValue}
                                            value={mainLancamentoRowData && mainLancamentoRowData['lote'] ? mainLancamentoRowData['lote'] : ''}
                                            onChange={async e => {
                                                const value = e.target.value;
                                                setMainLancamentoRowData(prev => prev ? { ...prev, lote: value } : prev);
                                            }}
                                            style={{ marginTop: '0px', width: '102%', marginLeft: '-1px' }}
                                        >
                                            <option disabled value=''>Lote</option>
                                            {lotesOpcoes.map((loteNum, idx) => {
                                                // Tenta buscar o loteCustomizado correspondente
                                                let customLabel = '';
                                                if (Array.isArray(mainLancamentoRowData?.LotesPecas)) {
                                                    const loteObj = mainLancamentoRowData.LotesPecas.find(l => String(l.lote) === String(loteNum));
                                                    customLabel = loteObj?.loteCustomizado;
                                                }
                                                return (
                                                    <option value={loteNum} key={loteNum}>
                                                        {customLabel ? customLabel : `Lote ${loteNum}`}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </div>
                                    <div className={styles.lancamentoHeaderItem} style={{ minWidth: 80, maxWidth: 120, marginRight: 0 }}>
                                        <div className={styles.lancamentoHeaderLabel}>PEÇA</div>
                                        <div className={styles.lancamentoHeaderValue} style={{ padding: 0 }}>
                                            {(() => {
                                                const loteSelecionado = mainLancamentoRowData && mainLancamentoRowData['lote'];
                                                const lotesPecas = mainLancamentoRowData && Array.isArray(mainLancamentoRowData.LotesPecas) ? mainLancamentoRowData.LotesPecas : [];
                                                if (loteSelecionado && lotesPecas.length > 0) {
                                                    if (!showMiniModalEditarNomePeca) {
                                                        const loteNum = Number(loteSelecionado);
                                                        const opcoesPeca = retornaPecasDoLote(lotesPecas, loteNum, analisarTotalPecasArr);
                                                        // react-select custom dropdown
                                                        const Select = require('react-select').default;
                                                        const customOptionsPeca = opcoesPeca.map(num => {
                                                            const analisada = pecasAnalisadas.includes(String(num));
                                                            return {
                                                                value: num,
                                                                label: (
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0 }}>
                                                                        {analisesPeca.some(a => String(a.peca) === String(num)) && (
                                                                            <button
                                                                                type="button"
                                                                                style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer', marginRight: 4 }}
                                                                                onClick={e => {
                                                                                        e.stopPropagation();
                                                                                        handleAbrirMiniModalEditarNomePeca(num);
                                                                                    }}
                                                                                aria-label={`Editar Peça ${num}`}
                                                                            >
                                                                                <svg width="16" height="17" viewBox="0 0 20 20" fill="none">
                                                                                    <path d="M4 13.5V16H6.5L14.87 7.63L12.37 5.13L4 13.5Z" stroke="#202D3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    <path d="M11.13 6.37L13.63 8.87" stroke="#202D3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </svg>
                                                                            </button>
                                                                        )}
                                                                        <span style={{ fontWeight: analisada ? 700 : 500, color: analisada ? 'green' : '#202D3B', whiteSpace: 'nowrap', fontSize: '0.93em', marginRight: '6px' }}>{`Peça ${num}`}</span>
                                                                    </div>
                                                                ),
                                                                isDisabled: analisada,
                                                                textLabel: `Peça ${num}`,
                                                            };
                                                        });
                                                        const selectedOptionPeca = customOptionsPeca.find(opt => String(opt.value) === String(mainLancamentoRowData['peca']));
                                                        const selectedValuePeca = selectedOptionPeca
                                                            ? {
                                                                value: selectedOptionPeca.value, label: (
                                                                    <span style={{ fontWeight: selectedOptionPeca.isDisabled ? 700 : 500, color: selectedOptionPeca.isDisabled ? 'green' : '#202D3B', width: '100%', display: 'block', textAlign: 'center' }}>{selectedOptionPeca.textLabel}</span>
                                                                )
                                                            }
                                                            : null;
                                                        return (
                                                            <Select
                                                                options={customOptionsPeca}
                                                                value={selectedValuePeca}
                                                                onChange={opt => {
                                                                    if (opt && !opt.isDisabled) {
                                                                        setMainLancamentoRowData(prev => prev ? { ...prev, peca: opt.value } : prev);
                                                                    }
                                                                }}
                                                                isOptionDisabled={opt => opt.isDisabled}
                                                                placeholder="Peça"
                                                                menuIsOpen={showMiniModalEditarNomePeca ? false : undefined}
                                                                styles={{
                                                                    control: base => ({ ...base, minHeight: 28, height: 28, fontSize: '0.9rem', borderColor: '#ccc', boxShadow: 'none' }),
                                                                    valueContainer: base => ({ ...base, height: 28 }),
                                                                    input: base => ({ ...base, margin: 0, padding: 0 }),
                                                                    indicatorsContainer: base => ({ ...base, height: 28, pointerEvents: showMiniModalEditarNomePeca ? 'none' : 'auto', opacity: showMiniModalEditarNomePeca ? 0.5 : 1 }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        backgroundColor: state.isSelected ? '#e6f0fa' : state.isFocused ? '#f5faff' : '#fff',
                                                                        color: state.isDisabled ? 'green' : '#202D3B',
                                                                        fontWeight: state.isDisabled ? 700 : 500,
                                                                        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                                                                    }),
                                                                    singleValue: base => ({ ...base, color: '#202D3B', fontWeight: 600, width: '100%', textAlign: 'center' }),
                                                                    menu: base => ({ ...base, zIndex: 20000, display: showMiniModalEditarNomePeca ? 'none' : undefined }),
                                                                    menuList: (base) => ({
                                                                        ...base,
                                                                        maxHeight: 6 * 40, // 6 opções de 40px cada
                                                                        overflowY: 'auto',
                                                                        overflowX: 'hidden',
                                                                        paddingRight: 0,
                                                                        scrollbarWidth: 'thin',
                                                                        '::-webkit-scrollbar': {
                                                                            width: 6,
                                                                        },
                                                                    })
                                                                }}
                                                                isClearable={false}
                                                                menuPlacement="bottom"
                                                                onMenuOpen={() => setMenuIsOpenPeca(true)}
                                                                onMenuClose={() => setMenuIsOpenPeca(false)}
                                                                isSearchable={false}
                                                            />
                                                        );
                                                    }
                                                    return null;
                                                } else {
                                                    return <span style={{ color: '#aaa' }}>Selecione um lote</span>;
                                                }
                                            })()}
                                        </div>
                                    </div>
                                    {/* Bloco NOME PEÇA */}
                                    <div className={styles.lancamentoHeaderItem} style={{ minWidth: 80, maxWidth: 120, marginRight: 15 }}>
                                        <div className={styles.lancamentoHeaderLabel}>NOME PEÇA</div>
                                        <div className={styles.lancamentoHeaderValue} style={{ padding: 0 }}>
                                            <input
                                                type="text"
                                                className={styles.lancamentoHeaderValue}
                                                placeholder="Nome da peça"
                                                value={mainLancamentoRowData && mainLancamentoRowData['nomePeca'] ? mainLancamentoRowData['nomePeca'] : ''}
                                                onChange={e => setMainLancamentoRowData(prev => ({ ...prev, nomePeca: e.target.value }))}
                                                style={{ width: '100%', minWidth: 60, maxWidth: 120, fontWeight: 500, fontSize: '0.75rem', color: '#202D3B', textTransform: 'uppercase', padding: '2px 6px' }}
                                            />
                                        </div>
                                        {/* Mini Modal para editar nome da peça */}
                                        <MiniModalEditarNomePeca
                                            show={showMiniModalEditarNomePeca}
                                            onClose={() => setShowMiniModalEditarNomePeca(false)}
                                            styles={styles}
                                            analisesPeca={analisesPeca}
                                            pecaNum={miniModalPecaNum}
                                            patchNomePeca={patchNomePeca}
                                            setAnalisesPeca={setAnalisesPeca}
                                            setDefeitosGrid={setDefeitosGrid}
                                        />
                                    </div>
                                    {[{ label: 'LARGURA FORNECEDOR', key: 'larguraFornecedor' },
                                    { label: 'LARGURA INICIO', key: 'larguraInicio' },
                                    { label: 'LARGURA MEIO', key: 'larguraMeio' },
                                    { label: 'LARGURA FIM', key: 'larguraFim' },
                                    { label: 'OURELA', key: 'ourela' },
                                    { label: 'METRAGEM FORNECEDOR', key: 'metragemFornecedor' },
                                    { label: 'RELÓGIO', key: 'relogio' }
                                    ].map((item) => {
                                        let value = mainLancamentoRowData ? (mainLancamentoRowData[item.key] ?? '') : '';
                                        return (
                                            <div key={item.key} className={styles.lancamentoHeaderItem}>
                                                <div className={styles.lancamentoHeaderLabel}>{item.label}</div>
                                                <div className={styles.lancamentoHeaderValue} style={{ padding: 0 }}>
                                                    <input
                                                        type="text"
                                                        inputMode="decimal"
                                                        pattern="[0-9.]*"
                                                        style={{
                                                            width: '90%',
                                                            height: '32px',
                                                            border: 'none',
                                                            outline: 'none',
                                                            background: 'transparent',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            fontSize: '1rem',
                                                            color: '#22334a',
                                                        }}
                                                        value={value === undefined || value === null ? '' : String(value)}
                                                        onChange={e => {
                                                            let val = e.target.value.replace(',', '.').replace(/[^0-9.]/g, '');
                                                            setMainLancamentoRowData(prev => prev ? { ...prev, [item.key]: val } : prev);
                                                        }}
                                                        placeholder="0.00"
                                                    />
                                                    {["larguraFornecedor", "larguraMeio", "metragemFornecedor", "relogio"].includes(item.key) && (
                                                        <>
                                                            <img
                                                                src="/img/camera_icon.png"
                                                                alt="camera"
                                                                title="Anexar foto"
                                                                style={{
                                                                    width: 12,
                                                                    height: 12,
                                                                    cursor: 'pointer',
                                                                    marginRight: 2,
                                                                    filter: campoFotos[mainLancamentoRowData.peca]?.[item.key]?.file ? 'invert(41%) sepia(98%) saturate(749%) hue-rotate(85deg) brightness(95%) contrast(92%)' : 'none'
                                                                }}
                                                                onClick={() => {
                                                                    document.getElementById(`fileInput_${item.key}`)?.click();
                                                                }}
                                                            />
                                                            {["larguraMeio", "metragemFornecedor", "relogio"].includes(item.key) && (
                                                                <span style={{ color: 'black', fontWeight: 700, marginRight: 2 }}>*</span>
                                                            )}
                                                            <input
                                                                id={`fileInput_${item.key}`}
                                                                type="file"
                                                                accept=".jpg,.jpeg,image/jpg,image/jpeg"
                                                                style={{ display: 'none' }}
                                                                onChange={e => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                                                                        if (ext === '.jpg' || ext === '.jpeg') {
                                                                            setCampoFotos(prev => ({
                                                                                ...prev,
                                                                                [mainLancamentoRowData.peca]: {
                                                                                    ...(prev[mainLancamentoRowData.peca] || {}),
                                                                                    [item.key]: { file }
                                                                                }
                                                                            }));
                                                                            toast.success('Arquivo salvo com sucesso!');
                                                                        } else {
                                                                            toast.error('Apenas arquivos .jpg ou .jpeg são permitidos.');
                                                                        }
                                                                        e.target.value = '';
                                                                    }
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {/* BLOCO 3: Botões de defeito à direita */}
                                    <div className={styles.defeitoBox} style={{ display: (acabamentoConfirmado || (mainLancamentoRowData?.tipoTecido === 'tinto' || mainLancamentoRowData?.tipoTecido === 'estampado')) ? 'flex' : 'none' }}>
                                        {/* <span className={styles.defeitoLabel} style={{ marginBottom: 4, alignSelf: 'center' }}>POSSUI DEFEITO?</span> */}
                                        <div style={{ display: 'flex', gap: 0, justifyContent: 'center' }}>
                                            <div className={styles.defeitoBtnRow}>
                                                {(() => {
                                                    const obrigatorios = [
                                                        'lote', 'peca', 'larguraFornecedor',
                                                        'larguraInicio', 'larguraMeio', 'larguraFim',
                                                        'ourela', 'metragemFornecedor', 'relogio'
                                                    ];
                                                    const obrigatoriosFoto = [
                                                        'larguraMeio', 'metragemFornecedor', 'relogio'
                                                    ];
                                                    const filled = obrigatorios.every(key => {
                                                        const v = mainLancamentoRowData && mainLancamentoRowData[key];
                                                        return v !== undefined && v !== null && (String(v).trim() !== '' || v === 0 || v === '0' || v === 0.0 || v === '0.00');
                                                    }) && obrigatoriosFoto.every(key => {
                                                        return campoFotos[mainLancamentoRowData.peca]?.[key]?.file;
                                                    });
                                                    return (
                                                        <>
                                                            {/* Botão SIM: abre o sub-modal de defeitos */}
                                                            <button
                                                                className={styles.btnSim + (!filled ? ' btn-disabled' : '')}
                                                                disabled={!filled}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setShowDefeitoSubModal(true);
                                                                }}
                                                            >ADICIONAR DEFEITOS</button>
                                                            {/* Botão NÃO: ação já implementada */}
                                                            <button
                                                                className={styles.btnNao + (!filled ? ' ' + styles.btnSim + ' btn-disabled' : '')}
                                                                disabled={!filled}
                                                                onClick={async e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    // Chama o backend para identificar o modal tonalidade
                                                                    if (mainLancamentoRowData) {
                                                                        const id = mainLancamentoRowData.idMpTriangulacaoRev;
                                                                        const lote = mainLancamentoRowData.lote;
                                                                        const qtdePecas = mainLancamentoRowData.LotesPecas ? mainLancamentoRowData.LotesPecas.length : 0;
                                                                        // Supondo que getModalTonalidadeTipo aceite qtdePecas como terceiro argumento
                                                                        const modalTipo = await getModalTonalidadeTipo(id, lote, qtdePecas);
                                                                        if (Array.isArray(modalTipo)) {
                                                                            // Sempre abre o modal 2 e depois o 3
                                                                            const abrirModalSequencia = async (tipos) => {
                                                                                for (const tipo of tipos) {
                                                                                    if (tipo === 2) {
                                                                                        setModalTonalidadeTipo('segunda');
                                                                                        setShowTonalidadeModal(true);
                                                                                        // Aguarda o usuário finalizar o modal antes de abrir o próximo
                                                                                        await new Promise(resolve => {
                                                                                            const handler = () => {
                                                                                                setShowTonalidadeModal(false);
                                                                                                resolve();
                                                                                            };
                                                                                            // Supondo que finalizarTonalidadeModal chama handler
                                                                                            window._finalizarTonalidadeModalHandler = handler;
                                                                                        });
                                                                                    } else if (tipo === 3) {
                                                                                        setModalTonalidadeTipo('última');
                                                                                        setShowTonalidadeModal(true);
                                                                                        await new Promise(resolve => {
                                                                                            const handler = () => {
                                                                                                setShowTonalidadeModal(false);
                                                                                                resolve();
                                                                                            };
                                                                                            window._finalizarTonalidadeModalHandler = handler;
                                                                                        });
                                                                                    }
                                                                                }
                                                                            };
                                                                            abrirModalSequencia(modalTipo);
                                                                            return;
                                                                        } else {
                                                                            // Definição das variáveis de quantidade de peças
                                                                            const qtdePecasParaAnaliseDoPedido = mainLancamentoRowData?.qtdePecas || 0;
                                                                            const qtdeTotalPecasAnalisadasPedido = analisesPeca?.length || 0;
                                                                            if (modalTipo === 1) {
                                                                                setModalTonalidadeTipo('primeira');
                                                                                setShowTonalidadeModal(true);
                                                                                return;
                                                                            } else if (modalTipo === 2) {
                                                                                setModalTonalidadeTipo('segunda');
                                                                                setShowTonalidadeModal(true);
                                                                                return;
                                                                            } else if (modalTipo === 3) {
                                                                                setModalTonalidadeTipo('última');
                                                                                setShowTonalidadeModal(true);
                                                                                return;
                                                                            }
                                                                            // Verificação extra: se faltar apenas uma peça para análise no pedido, abrir modal 3
                                                                            if (
                                                                                qtdePecasParaAnaliseDoPedido > 0 &&
                                                                                qtdeTotalPecasAnalisadasPedido === qtdePecasParaAnaliseDoPedido - 1
                                                                            ) {
                                                                                setModalTonalidadeTipo('última');
                                                                                setShowTonalidadeModal(true);
                                                                                return;
                                                                            }
                                                                        }
                                                                    }
                                                                    if (typeof registrarAnalisePeca === 'function' && mainLancamentoRowData) {
                                                                        const parseFloatOrNull = v => {
                                                                            if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                                                                            const n = parseFloat(String(v).replace(',', '.'));
                                                                            return isNaN(n) ? null : n;
                                                                        };
                                                                        // Campos esperados pelo backend
                                                                        const payload = {
                                                                            idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                                                                            pedido: mainLancamentoRowData.pedido,
                                                                            lote: parseFloatOrNull(mainLancamentoRowData.lote),
                                                                            peca: parseFloatOrNull(mainLancamentoRowData.peca),
                                                                            larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                                                                            larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                                                                            larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                                                                            larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                                                                            ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                                                                            metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                                                                            relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                                                                            idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(item => item.lote == mainLancamentoRowData.lote)?.idMpTriangulacaoRevLotesPecas,
                                                                            pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
                                                                        };
                                                                        const formData = new FormData();
                                                                        formData.append('jsonBody', JSON.stringify(payload));
                                                                        [
                                                                            'larguraFornecedor',
                                                                            'larguraMeio',
                                                                            'metragemFornecedor',
                                                                            'relogio'
                                                                        ].forEach(campo => {
                                                                            const fileObj = campoFotos?.[mainLancamentoRowData?.peca]?.[campo];
                                                                            if (fileObj && fileObj.file) {
                                                                                const nomeArquivo = {
                                                                                    larguraFornecedor: 'imagemLarguraFornecedor',
                                                                                    larguraMeio: 'imagemLarguraMeio',
                                                                                    metragemFornecedor: 'imagemMetragemFornecedor',
                                                                                    relogio: 'imagemRelogio'
                                                                                }[campo];
                                                                                const ext = fileObj.file.name.substring(fileObj.file.name.lastIndexOf('.')).toLowerCase();
                                                                                if (ext === '.jpg' || ext === '.jpeg') {
                                                                                    formData.append('files', fileObj.file, `${nomeArquivo}${ext}`);
                                                                                } else {
                                                                                    toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                                                                                }
                                                                            }
                                                                        });
                                                                        setLoadingModal(true);
                                                                        const novaAnalise = await registrarAnalisePeca(formData, true);
                                                                        if (novaAnalise) {
                                                                            setAnalisesPeca(prev => {
                                                                                const novoArray = [...prev, novaAnalise];
                                                                                return novoArray;
                                                                            });
                                                                        }
                                                                        setLoadingModal(false);
                                                                    }
                                                                    setMainLancamentoRowData(prev => {
                                                                        if (!prev) return prev;
                                                                        return {
                                                                            ...prev,
                                                                            peca: '',
                                                                            larguraFornecedor: '',
                                                                            larguraInicio: '',
                                                                            larguraMeio: '',
                                                                            larguraFim: '',
                                                                            ourela: '',
                                                                            metragemFornecedor: '',
                                                                            relogio: '',
                                                                            pontuacao: '',
                                                                            nomePeca: ''
                                                                        };
                                                                    });
                                                                    setCampoFotos({}); // Limpa todos os arquivos anexados
                                                                    await carregarStatus();
                                                                }}
                                                            >FINALIZAR PEÇA</button>
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    <TonalidadeModal
                                        show={showTonalidadeModal}
                                        modalTonalidadeTipo={modalTonalidadeTipo}
                                        campoFotos={campoFotos}
                                        setCampoFotos={setCampoFotos}
                                        indiceSelecionado={indiceSelecionado}
                                        setIndiceSelecionado={setIndiceSelecionado}
                                        statusSelecionado={statusSelecionado}
                                        setStatusSelecionado={setStatusSelecionado}
                                        indicesModalTonalidade={indicesModalTonalidade}
                                        mainLancamentoRowData={mainLancamentoRowData}
                                        aprovadorTecidoTinto={aprovadorTecidoTinto}
                                        aprovadorTecidoEstampado={aprovadorTecidoEstampado}
                                        setLoadingModal={setLoadingModal}
                                        styles={styles}
                                        // Props adicionais para a função finalizarTonalidadeModal
                                        setShowTonalidadeModal={setShowTonalidadeModal}
                                        defeitos={defeitos}
                                        registrarAnalisePeca={registrarAnalisePeca}
                                        registrarAnalisePecaComDefeitos={registrarAnalisePecaComDefeitos}
                                        setAnalisesPeca={setAnalisesPeca}
                                        setDefeitosGrid={setDefeitosGrid}
                                        setMainLancamentoRowData={setMainLancamentoRowData}
                                        setDefeitos={setDefeitos}
                                        carregarStatus={carregarStatus}
                                        onTonalidadeFinish={onTonalidadeFinish}
                                        // Props para acumular imagens de tonalidade parciais
                                        tonalidadeImagensAcumuladas={tonalidadeImagensAcumuladas}
                                        onPartialTonalidadeSave={({ tonalidade, imagens }) => {
                                            // imagens: [{ file, name }]
                                            setTonalidadeImagensAcumuladas(prev => {
                                                const novos = Array.isArray(imagens) ? imagens : [];
                                                return [...prev, ...novos];
                                            });
                                        }}
                                        // permite que o modal limpe as imagens acumuladas após envio final
                                        clearTonalidadeImagens={() => setTonalidadeImagensAcumuladas([])}
                                    />
                                    <DefeitoModal
                                        show={showDefeitoSubModal}
                                        onClose={() => setShowDefeitoSubModal(false)}
                                        defeitos={defeitos}
                                        setDefeitos={setDefeitos}
                                        opcoesDefeito={opcoesDefeito}
                                        opcoesLocalizacao={opcoesLocalizacao}
                                        opcoesTamanho={opcoesTamanho}
                                        customSelectStyles={customSelectStyles}
                                        mainLancamentoRowData={mainLancamentoRowData}
                                        analisesPeca={analisesPeca}
                                        setAnalisesPeca={setAnalisesPeca}
                                        setDefeitosGrid={setDefeitosGrid}
                                        setMainLancamentoRowData={setMainLancamentoRowData}
                                        campoFotos={campoFotos}
                                        setLoadingModal={setLoadingModal}
                                        registrarAnalisePecaComDefeitos={registrarAnalisePecaComDefeitos}
                                        getModalTonalidadeTipo={getModalTonalidadeTipo}
                                        setModalTonalidadeTipo={setModalTonalidadeTipo}
                                        setShowTonalidadeModal={setShowTonalidadeModal}
                                        styles={styles}
                                    />
                                </div>
                                {/* Campo de check Tinto/Estampado */}
                                {(!mainLancamentoRowData?.tipoTecido || mainLancamentoRowData?.tipoTecido === '' || mainLancamentoRowData?.tipoTecido === null) && !acabamentoConfirmado && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 0, marginTop: 16, justifyContent: 'center', width: '100%' }}>
                                        <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#202D3B', marginRight: 12 }}>Tipo Tecido:</span>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                            <input
                                                type="radio"
                                                name="tipoAcabamento"
                                                value="tinto"
                                                checked={tipoAcabamento === 'tinto'}
                                                onClick={e => {
                                                    if (tipoAcabamento === 'tinto') {
                                                        setTipoAcabamento('');
                                                    } else {
                                                        setTipoAcabamento('tinto');
                                                    }
                                                }}
                                                style={{ accentColor: '#175699ff' }}
                                            />
                                            Tinto
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                            <input
                                                type="radio"
                                                name="tipoAcabamento"
                                                value="estampado"
                                                checked={tipoAcabamento === 'estampado'}
                                                onClick={e => {
                                                    if (tipoAcabamento === 'estampado') {
                                                        setTipoAcabamento('');
                                                    } else {
                                                        setTipoAcabamento('estampado');
                                                    }
                                                }}
                                                style={{ accentColor: '#175699ff' }}
                                            />
                                            Estampado
                                        </label>
                                        {tipoAcabamento && (
                                            <button
                                                type="button"
                                                style={{ marginLeft: 18, padding: '6px 18px', fontWeight: 600, fontSize: '1rem', background: '#202D3B', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                                                onClick={async () => {
                                                    if (typeof editarTipoTecido === 'function' && mainLancamentoRowData?.idMpTriangulacaoRev) {
                                                        await editarTipoTecido({
                                                            idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                                                            tipoTecido: tipoAcabamento
                                                        });
                                                    }
                                                    setMainLancamentoRowData(prev => prev ? { ...prev, tipoTecido: tipoAcabamento } : prev);
                                                    setAcabamentoConfirmado(tipoAcabamento);
                                                }}
                                            >
                                                Selecionar
                                            </button>
                                        )}
                                    </div>
                                )}
                                {/* BLOCO 4: Linha divisória */}
                                <div style={{ width: '100%', height: '2px', background: '#111', margin: '32px 0 0 0', borderRadius: '1px' }} />
                                {analisesPeca.length === 0 && (
                                    <div style={{ color: '#aaa', margin: '0', textAlign: 'center' }}>Nenhuma análise registrada ainda.</div>
                                )}
                                {/* BLOCO 4: Accordion de análise de peça */}
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', marginTop: '10px' }}>
                                    {/* Bloco preto */}
                                    <div style={{
                                        background: '#202D3B',
                                        color: '#fff',
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        padding: '6px 10px',
                                        borderTopLeftRadius: '4px',
                                        borderBottomLeftRadius: '4px',
                                    }}>
                                        RESUMO DO PEDIDO:
                                    </div>

                                    {/* Bloco branco */}
                                    <div style={{
                                        background: '#fff',
                                        color: '#111',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        padding: '6px 10px',
                                        border: '1px solid #ddd',
                                        borderTopRightRadius: '4px',
                                        borderBottomRightRadius: '4px',
                                        minWidth: '180px'
                                    }}>
                                        {statusAtualPedido ?? 'Carregando...'}
                                    </div>
                                </div>
                                <div
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '12px', marginBottom: '0', cursor: 'pointer' }}
                                    onClick={() => setOpenAnaliseAccordion(v => !v)}
                                    aria-expanded={openAnaliseAccordion}
                                    tabIndex={0}
                                    role="button"
                                >
                                    <div className={styles.analiseSetaGrid}>
                                        <svg width="16" height="16" viewBox="0 0 16 16">
                                            {!openAnaliseAccordion ? (
                                                // Seta para baixo (reta)
                                                <path d="M4 7l4 4 4-4" stroke="#111" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                            ) : (
                                                // Seta para esquerda (reta)
                                                <path d="M11 4l-4 4 4 4" stroke="#111" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                            )}
                                        </svg>
                                    </div>
                                    <div style={{ background: '#fff', width: '100%', borderRadius: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', minWidth: 220, display: 'flex', alignItems: 'center', zIndex: 1, marginLeft: '20px', padding: '5px 3px', marginBottom: '-30px' }}>
                                        <span style={{ fontWeight: 700, fontSize: '1rem', color: '#111' }}>Análise Peça:</span>
                                    </div>
                                </div>
                                <AnaliseDefeitosBlock
                                    styles={styles}
                                    openAnaliseAccordion={openAnaliseAccordion}
                                    analisesPeca={analisesPeca}
                                    setAnalisesPeca={setAnalisesPeca}
                                    setPecasAnalisadas={setPecasAnalisadas}
                                    setMainLancamentoRowData={setMainLancamentoRowData}
                                    setDefeitosGrid={setDefeitosGrid}
                                    deletarAnalisePecaDefeito={deletarAnalisePecaDefeito}
                                    carregarStatus={carregarStatus}
                                    openDefeitosAccordion={openDefeitosAccordion}
                                    setOpenDefeitosAccordion={setOpenDefeitosAccordion}
                                    defeitosGrid={defeitosGrid}
                                    deletarDefeitoAnalisePeca={deletarDefeitoAnalisePeca}
                                />
                                <div className={styles.boxBtnFinalizarLancamento}>
                                    <button
                                        type="button"
                                        className={styles.btnFinalizarLancamento}
                                        onClick={async () => {
                                            setLoadingModal(true);
                                            try {
                                                if (mainLancamentoRowData?.idMpTriangulacaoRev) {
                                                    await finalizarRevisaoPedido(mainLancamentoRowData.idMpTriangulacaoRev);
                                                    setMainData([]);
                                                    setTimeout(async () => {
                                                        await handleFilterMainGrid();
                                                        setLoadingModal(false);
                                                        handleCloseMainLancamentoModal();
                                                    }, 500);
                                                }
                                            } catch (error) {
                                                console.error("Erro ao finalizar:", error);
                                                toast.error("Erro ao finalizar pedido.");
                                                setLoadingModal(false);
                                            }
                                        }}
                                    >
                                        Finalizar
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
            <MiniModalAuditoria
                show={showModal}
                onClose={handleCancel}
                date={selectedDate}
                setDate={setSelectedDate}
            />
            <UncheckModal
                show={showUncheckModal}
                onClose={handleUncheckCancel}
            />
            {/* Modal lançamento de lotes ao clicar na linha do grid */}
            <LoteModal
                show={showRowModal}
                onClose={handleCloseRowModal}
                rowModalData={rowModalData}
                numLotes={numLotes}
                setNumLotes={setNumLotes}
                lotesQtd={lotesQtd}
                setLotesQtd={setLotesQtd}
                lotesCustomizados={lotesCustomizados}
                setLotesCustomizados={setLotesCustomizados}
                analisarTotalPecasArr={analisarTotalPecasArr}
                setAnalisarTotalPecasArr={setAnalisarTotalPecasArr}
                showMainLancamentoModal={showMainLancamentoModal}
                mainLancamentoRowData={mainLancamentoRowData}
                setMainLancamentoRowData={setMainLancamentoRowData}
                setMainData={setMainData}
                setAnalisesPeca={setAnalisesPeca}
                setDefeitosGrid={setDefeitosGrid}
                setLotesOpcoes={setLotesOpcoes}
                setShowMainLancamentoModal={setShowMainLancamentoModal}
                patchLotesPecas={patchLotesPecas}
                carregarStatus={carregarStatus}
                fetchAnalisePecas={fetchAnalisePecas}
                fetchDefeitosPecas={fetchDefeitosPecas}
                continuarLotesPecas={continuarLotesPecas}
                buscarLotesNumericosPorId={buscarLotesNumericosPorId}
                retornaPecasDoLote={retornaPecasDoLote}
                styles={styles}
            />
        </div>
    );
};

export default RevisaoMateriaPrimaMain;